import React from 'react';
import PropTypes from 'prop-types';
import {
  Card, CardBody, Col, Row,
} from 'reactstrap';
import { formatVendorStatus } from '../../../../helpers/resourceItem';

const ItemInformation = ({
  resourceitem: {
    vendor,
    id,
    poNumber,
    invoiceNumber,
    status,
    orderTime,
  },
}) => (
  <Row>
    <Col xs={12}>
      <h3 className="page-title mb-0">
        Receiving Order Detail Page
      </h3>
    </Col>
    <Col md={12}>
      <Card className="pb-0">
        <CardBody className="pt-3 pb-0">
          <div className="project-summary">
            <Row>
              <Col lg={6}>
                <table className="project-summary__info ml-2 mb-0">
                  <tbody>
                    <tr>
                      <th>Database ID:</th>
                      <td>{ id }</td>
                    </tr>
                    <tr>
                      <th>Vendor:</th>
                      <td>{ vendor }</td>
                    </tr>
                    <tr>
                      <th>Created:</th>
                      <td>{ orderTime }</td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col lg={6}>
                <table className="project-summary__info ml-2">
                  <tbody>
                    <tr>
                      <th>Status:</th>
                      <td>{ formatVendorStatus(status) }</td>
                    </tr>
                    <tr>
                      <th>PO Number:</th>
                      <td>{ poNumber }</td>
                    </tr>
                    <tr>
                      <th>Invoice Number:</th>
                      <td>{ invoiceNumber }</td>
                    </tr>
                  </tbody>
                </table>
              </Col>
            </Row>
          </div>
        </CardBody>
      </Card>
    </Col>
  </Row>
);

ItemInformation.propTypes = {
  resourceitem: PropTypes.shape({
    vendor: PropTypes.string,
    id: PropTypes.number,
  }),
};

ItemInformation.defaultProps = {
  resourceitem: {},
};

export default ItemInformation;
